import type { TranslationMessages } from './types';

export const notifications: TranslationMessages = {
  new_order: {
    title: 'New Order',
    message: 'A new order has been placed',
  },
  low_stock: {
    title: 'Low Stock Alert',
    message: 'Inventory is running low. Please restock soon.',
  },
  system_update: {
    title: 'System Update',
    message: 'The POS system has been updated',
  },
};
